export default __webpack_public_path__ + "static/filewithdust-b3116a681740be1a5cf23980f5e404d8.png";